import addClasses from './addClasses.js';
import removeClasses from './removeClasses.js';
export default {
  addClasses,
  removeClasses
};


//////////////////
// WEBPACK FOOTER
// /Users/maxime/dev/heinrich-boch/web/app/themes/heinrich-bock/node_modules/swiper/core/classes/index.js
// module id = 79
// module chunks = 0